<template>
  <!-- 会议发布页 -->
  <div class="form-content-container">
    <Form
      class="form-container"
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      label-position="left"
    >
      <!-- <FormItem class="form-item" prop="title">
        <div class="title">
          <Input
            class="titleInput"
            v-model="formValidate.title"
            :autosize="true"
            type="textarea"
            placeholder="请输入会议名称(5-50字)"
          />
          <div class="number">
            <span :class="formValidate.title.length > 50 ? 'fontColor' : ''">{{
              formValidate.title.length
            }}</span>
            / 50
          </div>
        </div>
      </FormItem> -->
      <FormItem
        ref="FormItemTitle"
        class="form-item"
        prop="title"
        :rules="[
          { required: true, message: '标题不能为空', trigger: 'change | blur' },
          { validator: validatetitle, trigger: 'change | blur' },
        ]"
      >
        <div class="title titleRichEditor">
          <title-summary-editor
            v-if="titleFocus"
            bodyClass="chineseTitle"
            :id="'chineseTitle'"
            v-model.trim="formValidate.title"
            :initWithBold="true"
            initFontSize="36px"
            :minHeight="62"
            :placeholder="titlePlaceHolder"
            @changeValue="getTitle"
          ></title-summary-editor>
        </div>
        <div class="number">
          <span :class="wordCount > 50 ? 'fontColor' : ''">{{
            wordCount
          }}</span>
          / 50
        </div>
      </FormItem>
      <FormItem class="form-item" label="会议类型" prop="meetingType">
        <Select
          placeholder="请选择会议类型"
          v-model="formValidate.meetingType"
          style="width: 200px; margin-right: 10px"
        >
          <Option :value="1">线上会议</Option>
          <Option :value="2">线下会议</Option>
        </Select>
      </FormItem>
      <FormItem class="form-item" label="会议主图" prop="cover">
        <PictureUpload
          @handleUpload="formValidate.cover = $event"
          :cover="formValidate.cover"
        ></PictureUpload>
      </FormItem>
      <FormItem class="form-item" label="会议时间" :required="true">
        <FormItem prop="beginTime">
          <DatePicker
            type="datetime"
            placeholder="请输入开始时间"
            format="yyyy-MM-dd HH:mm"
            style="width: 200px"
            @on-change="beginTimeChange"
            :value="formValidate.beginTime"
          ></DatePicker>
        </FormItem>
        <div style="margin: 0 20px">-</div>
        <FormItem
          prop="endTime"
          :rules="[
            { required: true, message: '请选择结束时间', trigger: 'change' },
            { validator: validateEndTime, trigger: 'change' },
          ]"
        >
          <DatePicker
            style="width: 200px"
            type="datetime"
            placeholder="请输入结束时间"
            format="yyyy-MM-dd HH:mm"
            :value="formValidate.endTime"
            :time-picker-options="{
              steps: [1, 1],
              disabledHours,
              disabledMinutes,
              hideDisabledOptions: true,
            }"
            :options="endTimeOptions"
            @on-change="endTimeChange"
          ></DatePicker>
        </FormItem>
      </FormItem>
      <FormItem
        class="form-item"
        :label="formValidate.meetingType === 2 ? '会议地点' : '会议地址'"
        :required="true"
      >
        <FormItem prop="provinceCode" v-if="formValidate.meetingType === 2">
          <Select
            placeholder="选择省"
            v-model="formValidate.provinceCode"
            @on-open-change="getProvinces"
            @on-select="getCity"
            :not-found-text="loadingP ? '' : '无匹配数据'"
            :loading="loadingP"
            style="width: 200px; margin-right: 10px"
          >
            <Option
              v-for="item in provincesOptions"
              :key="item.code"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem prop="cityCode" v-if="formValidate.meetingType === 2">
          <Select
            placeholder="选择市"
            v-model="formValidate.cityCode"
            @on-select="formValidate.city = $event.label"
            :loading="loadingC"
            style="width: 200px; margin-right: 10px"
          >
            <Option
              v-for="item in cityOptions"
              :key="item.code"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          style="flex: 1"
          prop="address"
          :rules="{
            required: formValidate.meetingType === 1,
            message: '请输入会议地址',
            trigger: 'blur',
          }"
        >
          <Input
            v-model="formValidate.address"
            :placeholder="
              formValidate.meetingType === 2
                ? '请输入详细地址'
                : '请输入线上会议地址,如: http://meeting.cnknowledge.com'
            "
          />
        </FormItem>
      </FormItem>
      <FormItem
        class="form-item more-item"
        label="主办单位"
        :prop="'organizerList.' + 0 + '.name'"
        :rules="{
          required: true,
          message: '请至少输入第一项主办单位',
          trigger: 'blur',
        }"
      >
        <div
          class="item-input"
          v-for="(item, index) in formValidate.organizerList"
          :key="'organizerList' + index"
        >
          <Input v-model.trim="item.name" placeholder="请输入主办单位" />
          <div
            class="plus"
            @click="addItem('organizerList', index, 2)"
            v-if="formValidate.organizerList.length - 1 === index"
          >
            +
          </div>
        </div>
      </FormItem>
      <FormItem class="form-item more-item" label="承办单位">
        <div
          class="item-input"
          v-for="(item, index) in formValidate.undertakerList"
          :key="'undertakerList' + index"
        >
          <Input v-model.trim="item.name" placeholder="请输入承办单位" />
          <div
            class="plus"
            @click="addItem('undertakerList', index, 3)"
            v-if="formValidate.undertakerList.length - 1 === index"
          >
            +
          </div>
        </div>
      </FormItem>
      <FormItem class="form-item more-item" label="协办单位">
        <div
          class="item-input"
          v-for="(item, index) in formValidate.coOrganizerList"
          :key="'coOrganizerList' + index"
        >
          <Input v-model.trim="item.name" placeholder="请输入协办单位" />
          <div
            class="plus"
            @click="addItem('coOrganizerList', index, 1)"
            v-if="formValidate.coOrganizerList.length - 1 === index"
          >
            +
          </div>
        </div>
      </FormItem>
      <FormItem class="form-item more-item" label="合作期刊">
        <div
          class="item-input"
          v-for="(item, index) in formValidate.periodicals"
          :key="index"
        >
          <PeriodicalsSelect :periodical="item" />
          <div
            class="plus"
            @click="addItem('periodicals', index, 1)"
            v-if="formValidate.periodicals.length - 1 === index"
          >
            +
          </div>
        </div>
      </FormItem>
      <FormItem class="form-item" prop="keyword" label="标签">
        <Input
          placeholder="多个标签之间用英文逗号“,”隔开"
          v-model.trim="formValidate.keyword"
        />
      </FormItem>
      <FormItem
        class="form-item"
        label="摘要"
        prop="artSummary"
        :rules="{
          type: 'string',
          max: 500,
          message: '摘要超出字数限制',
          trigger: 'blur',
        }"
      >
        <div class="title abstract">
          <Input
            class="titleInput"
            v-model="formValidate.artSummary"
            :autosize="true"
            type="textarea"
            placeholder="请简单介绍会议,帮助用户快速了解内容，如不填写则默认抓取正文前500字用做展示"
          />
          <div>
            <span
              :class="formValidate.artSummary.length > 500 ? 'fontColor' : ''"
              >{{ formValidate.artSummary.length }}</span
            >
            / 500
          </div>
        </div>
      </FormItem>
      <FormItem
        class="form-item"
        prop="content"
        ref="FormItemContent"
        label="会议信息"
      >
        <Editor
          :id="'editor'"
          v-model="formValidate.content"
          :placeholder="'请输入会议内容'"
        />
      </FormItem>
      <FormItem class="form-item manuscript-item" label="征稿信息">
        <div style="display: flex; margin-bottom: 30px">
          <span class="plus" @click="openList('manuscript')">+</span>
          <span class="plus-text" @click="openList('manuscript')"
            >添加征稿采编</span
          >
        </div>
        <FormItem v-if="formValidate.edits.length > 0">
          <div
            style="color: #333; margin-bottom: 10px"
            v-for="item in formValidate.edits"
            :key="item.id"
          >
            <span style="font-size: 18px">{{ item.userName }}</span>
            <span style="font-size: 14px">({{ item.post }})</span>
            <span style="margin-left: 30px; font-size: 14px"
              >联系方式：{{ item.phone }}</span
            >
          </div>
        </FormItem>
        <FormItem>
          <Editor
            style="margin-top: 20px"
            :id="'manuscriptEditor'"
            v-model="formValidate.solicitContent"
            :placeholder="'请输入征稿信息'"
          />
        </FormItem>
      </FormItem>
      <FormItem class="form-item manuscript-item" label="组委会信息">
        <div style="display: flex; margin-bottom: 30px">
          <span class="plus" @click="openList('members')">+</span>
          <span class="plus-text" @click="openList('members')"
            >添加组委会成员</span
          >
        </div>
        <div
          class="committee"
          v-for="item in formValidate.committees"
          :key="item.id"
        >
          <img
            v-if="item.headImg"
            :src="$global.imgUrl + item.headImg"
            style="width: 64px; height: 64px; border-radius: 50%"
            alt=""
          />
          <Big v-else width="64" height="64" size="20" :big="item.userName" />
          <div style="margin-left: 10px">
            <p>
              <span style="font-size: 24px; margin-right: 24px">{{
                item.userName
              }}</span>
              <span
                style="color: #666666"
                v-for="i in item.titles"
                :key="i.id"
                >{{ i.levelTwo }}</span
              >
            </p>
            <p>
              <span
                v-if="item.orgName"
                style="font-size: 16px; margin-right: 50px"
                >{{ item.orgName }}</span
              >
              <span style="color: #666" v-if="item.researchDirection"
                >研究方向：{{ item.researchDirection }}</span
              >
            </p>
          </div>
        </div>
      </FormItem>
      <FormItem class="form-item" label="会议联系人">
        <FormItem
          class="contact-item"
          prop="contactsName"
          :rules="[{ validator: validateRelation, trigger: 'blur' }]"
        >
          <Input
            v-model.trim="formValidate.contactsName"
            placeholder="请输入联系人姓名"
          />
        </FormItem>
        <FormItem
          style="flex: 1"
          prop="contactsInfo"
          :rules="[{ validator: validateRelation, trigger: 'blur' }]"
        >
          <Input
            v-model.trim="formValidate.contactsInfo"
            placeholder="请输入电话或邮箱"
          />
        </FormItem>
      </FormItem>
      <FormItem class="form-item" label="是否开启报名" prop="open">
        <RadioGroup v-model="formValidate.open">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        class="form-item ticket-item"
        label="门票设置"
        :required="true"
        v-if="formValidate.open === 1"
      >
        <p style="display: flex; margin-bottom: 40px">
          <span style="width: 221px; padding-left: 5px">票种名称</span>
          <span style="width: 180px; padding-left: 5px">票价</span>
          <span style="width: 180px; padding-left: 5px"
            >票数<span style="font-size: 10px"
              >（若不限制数量，则填0）</span
            ></span
          >
          <span style="width: 260px; padding-left: 5px">有效期</span>
          <!-- <span class="plus" @click="arrTickets">+</span> -->
        </p>
        <div
          class="tickets-list"
          v-for="(item, index) in formValidate.tickets"
          :key="index"
        >
          <FormItem
            style="width: 216px"
            class="ticket"
            :prop="'tickets.' + 0 + '.ticketName'"
            :rules="{
              required: true,
              message: '请至少输入第一项票种名称',
              trigger: 'blur',
            }"
          >
            <Input
              v-model.trim="item.ticketName"
              placeholder="请输入票种名称"
            />
          </FormItem>
          <FormItem
            style="width: 180px"
            class="ticket"
            :prop="'tickets.' + 0 + '.price'"
            :rules="{
              required: true,
              type: 'number',
              message: '请至少输入第一项票价',
              trigger: 'blur',
            }"
          >
            <InputNumber
              border="0"
              size="large"
              style="width: 100%"
              v-model="item.price"
              placeholder="请输入票价"
            ></InputNumber>
          </FormItem>
          <FormItem
            style="width: 180px"
            class="ticket"
            :prop="'tickets.' + 0 + '.quantity'"
            :rules="{
              required: true,
              type: 'number',
              message: '请至少输入第一项票数',
              trigger: 'blur',
            }"
          >
            <InputNumber
              size="large"
              style="width: 100%"
              v-model="item.quantity"
              placeholder="请输入票数"
            ></InputNumber>
          </FormItem>
          <FormItem
            class="ticket"
            style="flex: 1"
            :prop="'tickets.' + 0 + '.beginTime'"
            :rules="{
              type: 'string',
              required: true,
              message: '请输入有效期',
            }"
          >
            <DatePicker
              style="width: 100%"
              size="large"
              type="daterange"
              split-panels
              placeholder="请选择有效期"
              format="yyyy-MM-dd"
              :value="[item.beginTime, item.endTime]"
              :options="ticketTimeOptions"
              @on-change="
                (date) => {
                  (item.beginTime = date[0]), (item.endTime = date[1]);
                }
              "
            ></DatePicker>
          </FormItem>
        </div>
      </FormItem>
      <FormItem
        class="form-item"
        label="报名表单"
        v-if="formValidate.open === 1"
      >
        <RegistrationForm
          :signUps="formValidate.signUps"
          @signUpsChange="signUpsChange"
        />
      </FormItem>
      <FormItem class="form-item columnItem" label="发布栏目" prop="columnIds">
        <!-- <Checkbox :value="true" disabled></Checkbox>
          <span>{{ columnNum }}</span> -->
        <Tree
          :data="treeList"
          show-checkbox
          @on-check-change="changeCheck"
        ></Tree>
      </FormItem>
      <div class="submit-container">
        <Button @click="preview" :disabled="isShow" v-throttleClick="2000"
          >预览</Button
        >
        <Button
          @click="handleSubmit(formValidate, 1)"
          :disabled="canClick"
          v-throttleClick="2000"
          >保存</Button
        >
        <Button
          @click="handleSubmit(formValidate, 0)"
          :disabled="canClick"
          v-throttleClick="2000"
          >发布</Button
        >
      </div>
    </Form>
    <AuthenticationModel
      v-if="isFlag"
      @handleClose="isFlag = false"
    ></AuthenticationModel>
    <ManuscriptModal
      :periodicals="formValidate.periodicals"
      :showManuscript="showManuscript"
      :isArr="formValidate.edits"
      @visibleChange="manuscriptChange"
    />
    <MembersModal
      :showMembers="showMembers"
      :isArr="formValidate.committees"
      @closeModal="membersChange"
      @delList="membersDel"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ruleUtils from "@/utils/ruleValidate.js";
import Editor from "../../components/editor";
import PictureUpload from "../../components/PictureUpload.vue";
import AuthenticationModel from "../../components/AuthenticationModel.vue";
import RegistrationForm from "./components/registrationForm.vue";
import ManuscriptModal from "./components/manuscriptModal.vue";
import MembersModal from "./components/membersModal.vue";
import PeriodicalsSelect from "./components/periodicalsSelect";
import TitleSummaryEditor from "@/views/PCView/user/components/TitleSummaryEditor";
export default {
  components: {
    PictureUpload,
    AuthenticationModel,
    Editor,
    RegistrationForm,
    ManuscriptModal,
    MembersModal,
    PeriodicalsSelect,
    TitleSummaryEditor,
  },
  created() {
    // 认证
    if (this.userInfo.user.customerType === 1) {
      this.isFlag = true;
    }
    this.projectAndColumnListByType({
      type: 9,
    });
    if (this.$route.query.id) {
      this.getEcho();
      this.isShow = false;
    }
  },
  mounted() {
    this.titleFocus = true;
  },
  data() {
    return {
      isShow: true,
      canClick: false,
      isFlag: false,
      isUpdate: false, // 判断是不是修改表单
      loadingP: false, //选择地区省份列表加载
      loadingC: false, //选择地区城市列表加载
      showManuscript: false,
      showMembers: false,
      titleFocus: false,
      titlePlaceHolder: "请输入标题(0~50)字",
      wordCount: 0,
      provincesOptions: [], //省份下拉列表数据
      cityOptions: [], //城市下拉列表数据
      treeList: [], //发布栏目
      ruleValidate: ruleUtils,
      formValidate: {
        title: "",
        meetingType: 2,
        cover: "",
        beginTime: "",
        endTime: "",
        province: "",
        provinceCode: "",
        city: "",
        cityCode: "",
        address: "",
        organizerList: [{ name: "", type: 2 }],
        undertakerList: [{ name: "", type: 3 }],
        coOrganizerList: [{ name: "", type: 1 }],
        periodicals: [{ perName: "", perId: "" }],
        keyword: "",
        artSummary: "",
        content: "",
        edits: [],
        solicitContent: "",
        committees: [],
        contactsName: "",
        contactsInfo: "",
        open: 1,
        tickets: [
          {
            ticketName: "",
            price: 0,
            quantity: 0,
            beginTime: "",
            endTime: "",
          },
        ],
        signUps: [
          {
            code: "name",
            value: "姓名",
            must: 1,
          },
          {
            code: "phone",
            value: "手机",
            must: 1,
          },
          {
            code: "unit",
            value: "工作单位",
            must: 1,
          },
        ], // 会议报名表单
        status: 0,
        auditStatus: 1,
        columnIds: [],
      },
      endTimeOptions: {},
      ticketTimeOptions: {},
      disabledHours: [],
      disabledMinutes: [],
      previewData: {
        data: {
          articleId: this.$route.query.id ? this.$route.query.id : "",
          articleType: 8,
        },
      },
    };
  },
  computed: {
    ...mapState(["token", "userInfo"]),
    columnNum() {
      let str = "";
      if (sessionStorage.getItem("isSon") === "false") {
        if (this.userInfo.user.customerType === 4) {
          str = "百科号";
        } else if (this.userInfo.user.customerType === 5) {
          str = "机构号";
        } else if (
          this.userInfo.user.customerType === 1 ||
          this.userInfo.user.customerType === 2
        ) {
          str = "百家号";
        }
      } else {
        if (this.userInfo.user.subType === 1) {
          str = "百科号";
        } else if (this.userInfo.user.subType === 2) {
          str = "机构号";
        }
      }
      return str;
    },
  },
  watch: {
    "formValidate.content": {
      handler() {
        this.$nextTick(() => {
          this.$refs.FormItemContent.$emit("on-form-change"); // 对非View组件触发表单校验change方法
        });
      },
    },
    "formValidate.title": {
      handler() {
        this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
      },
      deep: true,
      // immediate: true,
    },
    "formValidate.beginTime": {
      handler(newVal) {
        this.ticketTimeOptions = {
          disabledDate(date) {
            return (
              date.valueOf() < Date.now() - 86400000 ||
              date.valueOf() > new Date(newVal).getTime() - 86400000
            );
          },
        };
      },
    },
  },
  methods: {
    // 联系人校验
    validateRelation(rule, value, callback) {
      if (
        (this.formValidate.contactsName !== "" ||
          this.formValidate.contactsInfo !== "") &&
        value === ""
      ) {
        return callback(new Error("请填写完整会议联系人信息"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 标题校验
    validatetitle(rule, value, callback) {
      if (this.wordCount < 5 || this.wordCount > 50) {
        return callback(new Error("标题限制5到50个字数"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    getTitle(params) {
      /* params接收富文本对象，以JSON字符串方式传递，需解析为对象；
      解析后格式如{id: "englishTitle",value:{default: ""}} */
      params = JSON.parse(params);
      // 获取富文本输入框ID，用于区分
      var editorId = params.id;

      // params.value获取富文本输入框的值，有两种可能的值，默认为对象类型 value:{default: ""}；一旦有值，则变为字符串类型，如value: '<p style="line-height: 1.5;">&nbsp;'
      let originalText = params.value; // 获取富文本输入框原始值
      if (typeof originalText == "object") originalText = "";

      // 定义正则表达式reg 过滤标签（无法正常保留<>,如遇<某某决议>这种，还需修改正则）
      var reg = new RegExp("<[^<>]+>", "g");
      // 过滤后的字符串内容，用于统计字数
      let countText = originalText.replace(reg, "");

      // 现将特殊字符$nbsp;替换成空格然后将其他特殊字符匹配成1来便于计数
      var reg2 = /\&[0-9a-z]+;/g;
      countText = countText.replace(/&nbsp;/gi, "");
      if (countText.match(reg2) != null && countText.match(reg2).length != 0) {
        countText = countText.replace(reg2, "1");
      }
      // 将原值中的额$nbsp;替换为普通空格(html中的空格)
      originalText = originalText.replace(/&nbsp;/gi, "");

      // 不为空时，保留sub,sup标签，过滤其他标签
      originalText = originalText.replace(/(?!<(\/?sub|\/?sup).*?>)<.*?>/g, "");
      originalText = originalText.trim();
      // 去掉头尾空格以计数
      countText = countText.trim();

      this.formValidate.title = originalText;
      countText = this.filterSubSup(countText);
      this.wordCount = countText.length;
      this.$refs.FormItemTitle.$emit("on-form-change"); // 对非View组件触发表单校验change方法
    },
    // 过滤字符串中的sub/sup标签，返回过滤后的字符串。以计字数
    filterSubSup(s) {
      if (s.indexOf("<sub>") != -1 || s.indexOf("<sup>") != -1) {
        s = s.replace(/<sub>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
        s = s.replace(/<sup>/gi, "");
        s = s.replace(/<\/sub>/gi, "");
      }
      return s;
    },
    // 校验征稿信息
    validateSolicitContent(rule, value, callback) {
      if (this.formValidate.edits.length === 0 && value === "") {
        return callback(new Error("请至少输入征稿信息"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 添加征稿采编提交
    manuscriptChange(arr) {
      if (arr) this.formValidate.edits = [...arr];
      this.showManuscript = false;
    },
    // 删除组委会信息选中项
    membersDel(obj) {
      if (obj.type === 2 && obj.customId) {
        this.formValidate.committees = this.formValidate.committees.filter(
          (item) => item.customId !== obj.customId
        );
      } else {
        this.formValidate.committees = this.formValidate.committees.filter(
          (item) => item.id !== obj.id
        );
      }
    },
    // 组委会信息提交
    membersChange(arr) {
      if (arr) this.formValidate.committees = [...arr];
      this.showMembers = false;
    },
    // 报名表单更改
    signUpsChange(arr) {
      this.formValidate.signUps = [...arr];
    },
    // 添加门票设置
    arrTickets() {
      let arr = this.formValidate.tickets;
      let obj = arr[arr.length - 1];
      let isFill = false;
      Object.values(obj).forEach((item) => {
        if (typeof item === "object") {
          if (item.some((i) => i === "")) {
            isFill = true;
            return;
          }
        } else {
          if (item === "") {
            isFill = true;
            return;
          }
        }
      });
      if (!isFill) {
        this.formValidate.tickets.push({
          ticketName: "",
          price: 0,
          quantity: 0,
          beginTime: "",
          endTime: "",
        });
      }
    },
    // 打开列表弹窗
    openList(tag) {
      if (tag === "manuscript") {
        this.showManuscript = true;
      } else {
        this.showMembers = true;
      }
    },
    // 预览
    async preview() {
      const resp = await this.$apis.userServe.setPreview({
        ...this.previewData.data,
      });
      let URL = this.$router.resolve({
        path: "/conferencepreview",
        query: {
          articleId: resp.data,
        },
      });
      window.open(URL.href, "_blank");
    },
    // 会议开始时间
    beginTimeChange(e) {
      var beginTime = new Date(e).getTime();
      // 当已经选中结束时间并修改开始时间时,防止选的开始时间在结束时间之后,再重新选择结束时间
      if (this.formValidate.endTime !== "") {
        var endTime = new Date(this.formValidate.endTime).getTime();
        if (beginTime > endTime) this.formValidate.endTime = "";
      }
      // 当已经选中门票有效期并修改开始时间时,防止选的开始时间在门票有效期之前,再重新选择门票有效期
      // if (this.formValidate.endTime !== "") {
      //   var endTime = new Date(this.formValidate.endTime).getTime();
      //   if (beginTime > endTime) this.formValidate.endTime = "";
      // }
      this.endTimeOptions = {
        disabledDate(date) {
          return date && date.valueOf() < beginTime - 86400000;
        },
      };
      this.formValidate.beginTime = e;
    },
    // 会议结束时间
    endTimeChange(e) {
      this.disabledHours = [];
      this.disabledMinutes = [];
      let beginTime = this.formValidate.beginTime;
      let begin = beginTime.split(" ")[0];
      let end = e.split(" ")[0];
      if (beginTime && begin === end) {
        // 当选择日期和开始日期一样时,时间选择器进行格式筛选出大于开始时间的时间段选择
        let hours = beginTime.split(" ")[1].split(":")[0];
        let minutes = beginTime.split(" ")[1].split(":")[1];
        this.disabledHours = Array.from(new Array(24).keys())
          .slice(-24)
          .filter((item) => item < hours);
        this.disabledMinutes = Array.from(new Array(60).keys())
          .slice(-60)
          .filter((item) => item < minutes);
      }
      this.formValidate.endTime = e;
    },
    // 会议时间校验
    validateEndTime(rule, value, callback) {
      let begin = new Date(this.formValidate.beginTime).getTime();
      let end = new Date(this.formValidate.endTime).getTime();
      if (begin > end) {
        return callback(new Error("会议结束时间应在开始时间之后"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    // 主办/承办/协办增加单位
    addItem(item, index, type) {
      if (item === "periodicals") {
        if (this.formValidate[item][index].perId === "") {
          return;
        }
        this.formValidate[item].push({ perName: "", perId: "" });
      } else {
        if (this.formValidate[item][index].name === "") {
          return;
        }
        this.formValidate[item].push({ name: "", type });
      }
    },
    // 获取选中的发布栏目
    changeCheck(checkArr) {
      let arr = checkArr.filter(
        (item) => !(item.children && item.children.length > 0)
      );
      this.formValidate.columnIds = arr.map((item) => item.id);
    },
    // 获取发布栏目
    async projectAndColumnListByType(argument) {
      const { data } = await this.$apis.userServe.projectAndColumnListByType(
        argument
      );
      this.treeList = [
        {
          title: data[0].projectName,
          expand: true,
          checked: false,
          children:
            data[0].columns &&
            data[0].columns.map((v) => {
              return {
                title: v.columnName,
                id: v.id,
                checked: false,
              };
            }),
        },
      ];
    },
    // 获取省份下拉列表
    async getProvinces(boolen) {
      if (boolen && this.provincesOptions.length === 0) {
        this.loadingP = true;
        const { content } = await this.$apis.userServe.proList();
        this.provincesOptions = [...content.provinceList];
        this.loadingP = false;
      }
    },
    // 获取城市下拉列表
    async getCity(query) {
      this.formValidate.province = query.label;
      this.loadingC = true;
      const { content } = await this.$apis.userServe.cityList({
        provinceCode: query.value,
      });
      this.cityOptions = [...content.cityList];
      this.loadingC = false;
    },
    // 提交表单按钮
    async handleSubmit(formValidate, auditStatus) {
      this.canClick = true;
      // 认证
      if (this.userInfo.user.customerType === 1) {
        this.isFlag = true;
        return;
      }
      this.$refs.formValidate.validate(async (valid) => {
        if (valid) {
          let data;
          if (this.isUpdate) {
            this.formValidate.id =
              this.$route.query.id || this.previewData.data.articleId || null;
            const resp = await this.$apis.userServe.conferenceUpdate(
              this.processing(auditStatus)
            );
            data = resp.data;
          } else {
            const resp = await this.$apis.userServe.conferenceSave(
              this.processing(auditStatus)
            );
            data = resp.data;
          }
          if (data.resultCode === "200") {
            this.isUpdate = true;
            this.$Message.success(auditStatus === 1 ? "保存成功" : "发布成功");
            this.previewData = data;
            this.isShow = false;
            this.canClick = false;
            if (auditStatus === 1) return;
            this.$router.push("/user/meetMan");
          } else {
            this.canClick = false;
            this.$Message.error(data.resultDesc);
          }
        } else {
          this.canClick = false;
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    // 提交数据处理
    processing(auditStatus) {
      let obj = this.$global.deepClone(this.formValidate);
      // 清除多余单位为空的数组
      if (obj.organizerList.length > 1) {
        obj.organizerList = obj.organizerList.filter(
          (item) => item.name !== ""
        );
      }
      obj.coOrganizerList = obj.coOrganizerList.filter(
        (item) => item.name !== ""
      );
      obj.undertakerList = obj.undertakerList.filter(
        (item) => item.name !== ""
      );
      obj.periodicals = obj.periodicals.filter(
        (item) => item.perName !== "" && item.perName !== null
      );

      // 当是线上会议的时候地点省份清空
      if (obj.meetingType === 1) {
        obj.city = "";
        obj.cityCode = "";
        obj.province = "";
        obj.provinceCode = "";
      }

      // 是更新或者新建文章
      obj.auditStatus = auditStatus;

      // 是否开启报名
      if (obj.open === 0) {
        obj.signUps = [];
        obj.tickets = [];
      }
      return obj;
    },
    // 回显
    async getEcho() {
      this.isUpdate = true;
      const { data } = await this.$apis.userServe.getMeetingDetailById({
        id: this.$route.query.id,
      });
      this.getProvinces(true);
      this.getCity({ value: data.provinceCode, label: data.province });
      this.formValidate = Object.assign({}, data);

      if (this.formValidate.coOrganizerList.length === 0) {
        this.formValidate.coOrganizerList.push({ name: "", type: 1 });
      }

      if (this.formValidate.undertakerList.length === 0) {
        this.formValidate.undertakerList.push({ name: "", type: 3 });
      }

      if (this.formValidate.periodicals.length === 0) {
        this.formValidate.periodicals.push({ perName: "", perId: "" });
      }

      if (this.formValidate.open === 0) {
        this.formValidate.signUps.push(
          {
            code: "name",
            value: "姓名",
            must: 1,
          },
          {
            code: "phone",
            value: "手机",
            must: 1,
          },
          {
            code: "unit",
            value: "工作单位",
            must: 1,
          }
        );
        this.formValidate.tickets.push({
          ticketName: "",
          price: 0,
          quantity: 0,
          beginTime: "",
          endTime: "",
        });
      }

      if (data.columnIds) {
        this.treeList.forEach((item) => {
          item.children.forEach((i) => {
            if (data.columnIds.some((t) => t === i.id)) {
              i.checked = true;
            }
          });
        });
      } else {
        this.formValidate.columnIds = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-tree ul li {
  margin: 0;
}
::v-deep .ivu-tree-children li {
  display: flex;
}
::v-deep .ivu-tree-children li .ivu-tree-arrow {
  display: none;
}
::v-deep .ivu-tree-children li .ivu-tree-children li {
  margin: 30px 40px 0 -60px;
}

::v-deep .ivu-tree-title:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-title-selected,
.ivu-tree-title-selected:hover {
  background-color: #fff;
}
::v-deep .ivu-tree-children li .ivu-tree-title {
  width: 100px;
}
::v-deep .ivu-radio-group {
  white-space: nowrap;
}
::v-deep .ivu-input-number {
  border: none;
}
.form-content-container {
  overflow: hidden;
  width: 1200px;
  margin: 38px auto 100px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.ivu-upload ::v-deep .ivu-upload-drag {
  border: none;
  display: flex;
  align-items: center;
}
::v-deep .ivu-upload {
  display: flex;
  align-items: center;
}
.ivu-input-wrapper ::v-deep textarea {
  border: none;
}
.form-container {
  margin: 0 auto 100px;
  padding: 60px 100px 0;
  width: 1200px;
  min-height: 1228px;
  background-color: #fff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  .form-item {
    padding-bottom: 25px;
    width: 100%;
    color: #999;
    &::v-deep .ivu-form-item-label {
      min-width: 80px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &::v-deep .ivu-form-item-content {
      display: flex;
    }
    &:not(:last-child) {
      border-bottom: 1px solid #dcdcdc;
    }
    ::v-deep .titleRichEditor {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-items: flex-end;
      .titleInput {
        flex: 1;
        margin-right: 0px;
      }
      #chineseTitle {
        padding-right: 50px;
      }
    }
    .number {
      text-align: right;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .fontColor {
      color: red !important;
    }
    .title {
      flex: 1;
      display: flex;
      align-items: flex-end;
      width: 100%;
      height: 100%;
      // line-height: 38px;
      position: relative;
      .titleInput {
        flex: 1;
        margin-right: 10px;
      }
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 36px;
          resize: none;
        }
      }
    }
    .abstract {
      ::v-deep .ivu-input-type-textarea {
        textarea {
          font-size: 14px;
          resize: none;
        }
      }
    }
    .columnItem {
      display: flex;
      &::v-deep .ivu-form-item-content {
        display: flex;
        align-items: flex-start;
        flex: 1;
      }
    }
  }
  .more-item {
    &::v-deep .ivu-form-item-content {
      display: inline-block;
      width: 900px;
      .item-input {
        display: flex;
        align-items: center;
        padding-top: 10px;
        width: 100%;
        &:first-child {
          padding-top: 0;
        }
        .ivu-input-wrapper {
          flex: 1;
        }
      }
      .plus {
        margin-left: 5px;
        padding: 0 6px;
        width: 30px;
        height: 30px;
        line-height: 25px;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
  .manuscript-item {
    &::v-deep .ivu-form-item-content {
      display: inline-block;
      width: 900px;
      .plus {
        margin-right: 12px;
        padding: 0 6px;
        width: 30px;
        height: 30px;
        line-height: 25px;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        font-size: 24px;
        cursor: pointer;
      }
      .plus-text {
        font-size: 14px;
        color: #1876f0;
        cursor: pointer;
      }
      .committee {
        display: flex;
        margin-bottom: 50px;
        color: #333333;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .contact-item {
    margin-right: 5px;
    padding-right: 5px;
    width: 355px;
    border-right: 1px solid #dcdcdc;
  }
  .ticket-item {
    &::v-deep .ivu-form-item-content {
      display: inline-block;
      .plus {
        margin-right: 12px;
        padding: 0 6px;
        width: 30px;
        height: 30px;
        line-height: 25px;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        font-size: 24px;
        cursor: pointer;
      }
      .tickets-list {
        display: flex;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .ticket {
          margin-right: 5px;
          padding-right: 5px;
          // height: 40px;
          border-right: 1px solid #dcdcdc;
          .ivu-form-item-content {
            width: 100%;
          }
          &:last-child {
            border-right: 0;
          }
        }
      }
    }
  }
}
.submit-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 80px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 70px;
  button {
    margin: 0 10px;
  }
}
</style>
